import { formatDate, isSameDay } from "date-fns";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import "modules/UsersDashboard/components/FilterDatePicker/FilterDatePicker.scss";

type FilterDatePickerProps = {
  value: string | null;
  clearable?: boolean;
  placeholder?: string;
  onChange: (dates: Date | null) => void;
};

export const FilterDatePicker = ({ value, onChange, clearable = false, placeholder }: FilterDatePickerProps) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const date = value ? new Date(value) : undefined;

  const handleClear = () => {
    onChange(null);
    setIsOpen(false);
  };

  const handleChange = (date: Date | null) => {
    onChange(date);
    setIsOpen(false);
  };

  const getDateValue = () => {
    if (!date) return placeholder ? placeholder : t("v8_select_date", "Select date");

    if (isSameDay(date, new Date())) return t("v8_today", "Today");
    return formatDate(date, DATE_FORMATS_FNS.dateMonthYear);
  };

  return (
    <div className="FilterDatePicker">
      <DatePicker
        calendarClassName="CalendarDatepicker"
        open={isOpen}
        onInputClick={() => setIsOpen(prev => !prev)}
        onClickOutside={() => setIsOpen(false)}
        date={date}
        onChange={handleChange}
        customInput={
          <div className="FilterDatePicker__custom-input-container">
            <span className={`FilterDatePicker__custom-input-text ${date ? "FilterDatePicker__custom-input-selected-value" : ""}`}>{getDateValue()}</span>
          </div>
        }
        selected={date}
      >
        {clearable && (
          <div className="react-datepicker-clear-date-container">
            <Button
              content={t("v8_clear_date", "Clear date")}
              icon="calendar"
              labelPosition="left"
              onClick={handleClear}
              className="react-datepicker-clear-date-button"
            />
          </div>
        )}
      </DatePicker>
    </div>
  );
};
